export function getTableUnknownColumnError(id: string) {
  return Error(`Could not find column with id "${id}".`);
}

export function getTableDuplicateColumnNameError(name: string) {
  return Error(`Duplicate column definition name provided: "${name}".`);
}

export function getTableMissingMatchingRowDefError(data: any) {
  return Error(
    `Could not find a matching row definition for the` +
      `provided row data: ${JSON.stringify(data)}`
  );
}

export function getTableMultipleDefaultRowDefsError() {
  return Error(
    `There can only be one default row without a when predicate function.`
  );
}
